import {Box, Heading, HStack, Show, Text, ThemeColorPath, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {EMPTY_PLACEHOLDER, Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

const ACCENT_SIZE = 2;

/** The page's headline figures, at 28px — well above the podium's, which sit at 21px. */
const VALUE_HEADING = 1;

interface SalesLeagueKpiColumnProps extends RequiredTestIdProps {
  /** Small square before the label, identifying the measure. */
  accentColor: ThemeColorPath;
  label: string;
  value: string | Nullish;
  unit?: string;
  footer: string;
  /** Period-over-period chip. Omitted when the comparison has no meaningful value. */
  changeChip?: ReactNode;
}

/** One measure inside the KPI panel. Carries no surface of its own — the panel is the card. */
export function SalesLeagueKpiColumn(props: SalesLeagueKpiColumnProps) {
  return (
    <VStack spacing={2} data-testid={suffixTestId('kpiColumn', props)}>
      <HStack spacing={2} align="center">
        <Box
          width={ACCENT_SIZE}
          height={ACCENT_SIZE}
          borderRadius="xSmall"
          backgroundColor={props.accentColor}
        />
        <Text size="xSmall" color="tertiary" noWrap>
          {props.label.toUpperCase()}
        </Text>
      </HStack>
      <HStack spacing={2} align="baseline">
        <Heading size={VALUE_HEADING}>{props.value ?? EMPTY_PLACEHOLDER}</Heading>
        <Show when={props.unit}>
          <Text size="small" color="tertiary">
            {props.unit}
          </Text>
        </Show>
      </HStack>
      <HStack spacing={2} align="center">
        <Text size="small" color="secondary">
          {props.footer}
        </Text>
        {props.changeChip}
      </HStack>
    </VStack>
  );
}
